import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight, Home } from 'lucide-react';
import { adoConceptos } from '../data/adoConceptos';
import Navbar from '../components/Navbar';
import SEOHead from '../components/SEOHead';

const ColeccionADOConceptos = () => (
  <div className="min-h-screen bg-white">
    <SEOHead
      title="Conceptos ADO — Vocabulario de Arquitectura de Decisión Organizacional | Edutech Pulse Lab"
      description="10 conceptos para nombrar los patrones y mecanismos organizacionales que determinan por qué las iniciativas estratégicas pierden impulso sin que nadie las cancele."
      canonicalUrl="/colecciones/ado/conceptos"
    />
    <Navbar />

    {/* ── Cabecera ─────────────────────────────────────────── */}
    <header className="bg-[#0c203b] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[40%] h-[3px] bg-[#C4933A]" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-10 pb-12 sm:pt-12 sm:pb-14 relative">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-1.5 text-[11px] text-white/35 mb-8 flex-wrap">
          <Link to="/" className="hover:text-white/60 transition-colors" aria-label="Inicio">
            <Home className="w-3 h-3" />
          </Link>
          <ChevronRight className="w-3 h-3 text-white/15" />
          <Link to="/colecciones" className="hover:text-white/60 transition-colors">Colecciones</Link>
          <ChevronRight className="w-3 h-3 text-white/15" />
          <Link to="/colecciones/ado" className="hover:text-white/60 transition-colors">ADO</Link>
          <ChevronRight className="w-3 h-3 text-white/15" />
          <span className="text-white/25">Conceptos</span>
        </nav>

        <p className="text-[11px] font-bold tracking-[0.2em] text-amber-400/55 uppercase mb-4">
          Notas ADO · 10 conceptos
        </p>
        <h1 className="text-[26px] sm:text-[32px] lg:text-[36px] font-bold text-white leading-[1.15] mb-4 max-w-xl tracking-tight">
          Vocabulario de Arquitectura de Decisión Organizacional
        </h1>
        <p className="text-[15px] sm:text-[16px] text-white/70 leading-relaxed max-w-2xl">
          10 conceptos para nombrar los patrones y mecanismos organizacionales que suelen permanecer invisibles — y que determinan por qué las iniciativas estratégicas pierden impulso sin que nadie las cancele.
        </p>
      </div>
    </header>

    {/* ── Grid de conceptos ───────────────────────────────── */}
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-100 border border-slate-100 rounded-2xl overflow-hidden">
          {adoConceptos.map((concepto) => (
            <Link
              key={concepto.slug}
              to={`/colecciones/ado/conceptos/${concepto.slug}`}
              className="group bg-white p-7 sm:p-8 hover:bg-slate-50/80 transition-colors duration-150 flex flex-col gap-3 min-h-[180px]"
            >
              {/* Número */}
              <span className="text-[11px] font-bold tracking-[0.2em] text-amber-500/70 uppercase font-mono">
                Concepto {concepto.num}
              </span>

              {/* Nombre */}
              <h2 className="text-[17px] sm:text-[19px] font-bold text-[#0F2844] leading-snug group-hover:text-slate-600 transition-colors tracking-[-0.01em]">
                {concepto.nombre}
              </h2>

              {/* Tensión */}
              <p className="text-[13px] sm:text-[14px] text-[#5F5E5A] italic leading-[1.6] flex-1">
                {concepto.tension}
              </p>

              {/* CTA */}
              <div className="flex items-center gap-1.5 text-[12px] font-semibold text-[#534AB7] mt-1 group-hover:gap-2 transition-all duration-200">
                Leer nota
                <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform duration-200" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>

    {/* ── CTA volver a la colección ─────────────────────────── */}
    <section className="border-t border-slate-100 bg-slate-50/50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div>
          <p className="text-[11px] font-semibold tracking-[0.18em] text-slate-400 uppercase mb-2">
            Serie ADO
          </p>
          <p className="text-[15px] text-[#4C586A] leading-snug">
            Los conceptos se construyen a través de los 7 artículos de la colección.
          </p>
        </div>
        <Link
          to="/colecciones/ado"
          className="group inline-flex items-center gap-2 text-[13px] sm:text-[14px] font-semibold text-[#0F2844] border border-slate-200 hover:border-slate-400 px-5 py-2.5 rounded-lg transition-all duration-200 flex-shrink-0"
        >
          Ver colección ADO
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform duration-200" />
        </Link>
      </div>
    </section>
  </div>
);

export default ColeccionADOConceptos;
